exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-graph-builder{display:flex}.cap-graph-builder .cap-graph-builder-element svg g body{position:fixed}.delete-block-modal .ant-modal-content{margin-top:130px}.delete-block-modal .ant-modal-content .ant-modal-close{margin-top:8px}.delete-block-modal .ant-modal-content .ant-modal-title{margin-top:10px}\n", ""]);

// exports
